import React, { useState } from 'react';
import { translateMonthToArabic } from '../helper/translateDayToArabic';
import { showFirst12Words, showFirst22Words } from '../helper/showFirstSixWords';
import { whiteCard } from '../common/cssclasses';
import { getFileName } from '../helper/getFileName';
import PdfViewerPopup from './pdf/PdfViewerPopup';

export default function LibraryCard({ index, item }) {
    const currentLanguage = localStorage.getItem('eahsLang') ?? 'en';
    const hasLink = !!item?.content;
    const [openPopup, setOpenPopup] = useState(false);
    const isImage = hasLink && /\.(jpg|jpeg|png|gif|webp)$/i.test(item?.content);

    return (
        <>
            <div className="col-xl-4 col-lg-6 col-md-12 col-sm-12 mb-main" key={index}
                onClick={() => {
                    if (hasLink) {
                        setOpenPopup(true);
                    }
                }}
                style={{ position: "relative", cursor: hasLink ? "pointer" : "" }}>
            <div className={whiteCard}>
                <div className='row h-100'>
                    <div style={{ position: 'relative' }}>
                        <div className='w-100 position-relative mb-form-group'>
                            <div>
                                <img src={item?.image} alt={getFileName(item?.image)} className="w-100 border-15" style={{ height: 430 }} />
                            </div>
                        </div>
                    </div>
                    <>
                        <div className="horseCardTitle mb-1">{showFirst12Words(item?.title)}</div>
                        {!!item?.subtitle &&
                            <p className="horseCardDescription fw-bold mb-2 ">{showFirst22Words(item?.subtitle)}</p>
                        }
                        <div className="newsPageNewsDateContainer mt-auto">
                            {/* <div className="newsPageNewsDay">{item?.dipslayDate[0]}</div> */}
                            <div className="newsPageNewsDay">{item?.dipslayDate[2]}</div>
                            {/* <div className="newsPageDateSpacer"></div>
                            <div className="newsPageMonthAndYear">
                                <span>{translateMonthToArabic(item?.dipslayDate[1], currentLanguage == 'en' ? 'en-US' : 'ar-AE')}</span>
                                <span>{item?.dipslayDate[2]}</span>
                            </div> */}
                        </div>
                    </>
                </div>
            </div>
            </div>
            <PdfViewerPopup 
                open={openPopup}
                onClose={() => setOpenPopup(false)}
                title={item?.title}
                attachmentUrl={item?.content}
            />
        </>
    )
}
